module.exports = __webpack_public_path__ + "media/images/icons/media-step-backward-871d0f070ff1018327651da898dad153.svg";